import { COURSES, UNITS } from 'constants/api';
import axios from 'utils/axios';

export const getCourses = async (params) => {
    const result = await axios.get(COURSES.v2.fetchCourses, {
        params
    });
    return result.data;
};

export const getUnits = async (params) => {
    const result = await axios.get(UNITS.v1.fetchUnit, {
        params: params || {}
        // paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
        // or 'brackets', or 'comma' depending on what your backend expects
    });
    return result.data;
};

export const getCourse = async (id) => {
    const result = await axios.get(COURSES.v1.fetchCourse.replace(':id', id));
    return result.data;
};

export const deleteCourse = async (courseIds) => {
    const result = await axios.delete(COURSES.v1.deleteCourse, {
        data: {
            courseIds
        }
    });
    return result.data;
};

export const createCourse = async (data) => {
    const result = await axios.post(COURSES.v1.createCourse, data);
    return result.data;
};

export const editCourse = async (id, data) => {
    const result = await axios.put(COURSES.v1.updateCourse, {
        courseId: id,
        ...data
    });
    return result.data;
};

export const copyCourse = async (id) => {
    const result = await axios.post(COURSES.v1.copyCourse, {
        courseId: id
    });
    return result.data;
};
